module.exports = __webpack_public_path__ + "img/abs_pack.486f7400.png";